import React from 'react';
import * as S from './styles';

interface NavbarCenterProps {
	children: React.ReactNode;
	align?: 'left' | 'center' | 'right';
}

const NavbarCenter = ({ children, align }: NavbarCenterProps) => {
	return <S.Base $align={align}>{children}</S.Base>;
};

export default NavbarCenter;
